import { apiService } from './apiService'

export interface AdminAccountRow {
  id: string
  username: string
  email: string | null
  phone: string | null
  role: 'SUPER_ADMIN' | 'ADMIN' | 'OPERATOR'
  status: 'ACTIVE' | 'INACTIVE'
  lastLoginAt: string | null
  createdAt: string
  updatedAt: string
}

/** 子账号须绑定手机号；用户名选填，不传则后端默认使用手机号作为登录名 */
export interface CreateAdminPayload {
  phone: string
  username?: string
  password: string
  role: 'SUPER_ADMIN' | 'ADMIN' | 'OPERATOR'
  email?: string
  status?: 'ACTIVE' | 'INACTIVE'
}

export interface UpdateAdminPayload {
  role?: 'SUPER_ADMIN' | 'ADMIN' | 'OPERATOR'
  status?: 'ACTIVE' | 'INACTIVE'
  email?: string
  phone?: string
}

export const adminsService = {
  async list(): Promise<AdminAccountRow[]> {
    return apiService.get<AdminAccountRow[]>('/admins')
  },

  async create(payload: CreateAdminPayload): Promise<AdminAccountRow> {
    return apiService.post<AdminAccountRow>('/admins', payload)
  },

  async update(id: string, payload: UpdateAdminPayload): Promise<AdminAccountRow> {
    return apiService.patch<AdminAccountRow>(`/admins/${id}`, payload)
  },

  async remove(id: string): Promise<void> {
    await apiService.delete(`/admins/${id}`)
  },
}
